import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import withRouter from "../../withRouter/withRouter";
import { ThunkCretorGetExperience } from "../../../context/reducers/experienceReducer";
import Experience from "./experiencePage";

function ExperienceContainer(props) {
    if(props.experience.data == null)
        props.getExperience();

    if (props.experience.data)
        return <Experience {...props.experience} />
}


const mapStateToProps = (state, ownProps) => {
    return {
        experience: state.experience
    }
}

const mapDispatchToProps = (dispatch) => ({
    getExperience: () => {
        dispatch(ThunkCretorGetExperience());
    }
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ExperienceContainer);